import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  onAuthStateChanged,
  setPersistence,
  browserLocalPersistence,
  signInWithPopup,
  signOut,
  User,
} from "firebase/auth";

const config = __FIREBASE_CONFIG__;

const isConfigValid = Boolean(config && config.apiKey && config.authDomain && config.projectId && config.appId);

const app = isConfigValid ? initializeApp(config) : null;
const auth = app ? getAuth(app) : null;
const provider = auth ? new GoogleAuthProvider() : null;

if (auth) {
  void setPersistence(auth, browserLocalPersistence);
}

export { auth, provider, isConfigValid, onAuthStateChanged, signInWithPopup, signOut, User };
